import { AxiosError } from "axios";
import { useCallback, useEffect, useState } from "react";
import api from "../../const/api";
import { APIPathGetMenuForLastMonthMenu, APIPathGetMenusByMembershipId } from "../../endpoint";
import { MenuListType } from "../../types/menus";
import firebase from "firebase/compat/app";
import {useSnackbar} from "../../components/organisms/SnackProvider";

export const useLastMonthMenuList = () => {
  const [menuVariationList, setMenuVariationList] = useState([] as MenuListType[]);
  const { showSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<AxiosError | null>(null);

  // TODO:: usefetchをより抽象化して使いやすくする or swrを入れる
  // handleClickが押されてMonthが変更 → fetchすることで初めてページが送られる作りなためuseEffectの副作用を使用しない
  const handleChangePage = useCallback(async (token: string) => {
    try {
      setIsLoading(true);
      const result = await api.get(APIPathGetMenuForLastMonthMenu, token);
      const data : any = {};
      data[""] = {"title" : "（設定なし）", "value" : ""};
      data["manual"] = {"title" : "手動設定（アップロードした先月末データ）", "value" : "manual"};
      for (const value of result.data) {
        data[value.id] = {"title" : value.name, "value" : value.id};
      }
      setMenuVariationList(data);
    } catch (e: unknown) {
      setError(error as AxiosError);
    } finally {
      setIsLoading(false);
    }
  },[]);  // eslint-disable-line
  
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user === null) {
        showSnackbar("ユーザを確認出来ませんでした", "error");
        return
      }
      await handleChangePage(await user.getIdToken(false));
    })
  }, [handleChangePage, showSnackbar]);

  return {
    isLoading,
    error,
    menuVariationList,
  }
};
